/**
* Created by lobin on 2019/12/10.
*/
<template>
	<div class="inbound">
		<el-radio-group v-model="inboundType" class="inbound-type" size="mini">
			<el-radio-button label="0">急速入库</el-radio-button>
			<el-radio-button label="1">批量入库</el-radio-button>
		</el-radio-group>
		<el-card class="box-card ruku" :style="'transform: translate(-50%, -50%) scale('+ (1 + scale / 100 ) +')'">
			<div slot="header" class="clearfix">
				<span>
					<el-button type="text">
						<span>
							包裹编号:<span v-if="parcelCode">{{parcelCode}}</span><span v-else>等待入库</span>
						</span>
					</el-button>
				</span>
				<el-slider style="float:right;width:40%;margin-top:-10px" v-model="scale" @change="scaleChange"></el-slider>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0">
				<el-form-item prop="shelf" class="shelf-select" v-if="!vipshelfstrict">
					<el-radio-group v-model="ruleForm.shelf" size="medium" v-if="shelves.length < 8"
					                class="shelf-radio-group">
						<el-radio-button v-for="item in shelves" :key="item._id" :label="item._id">{{ item.name }}
						</el-radio-button>
					</el-radio-group>
					<el-select v-model="ruleForm.shelf" placeholder="请选择货架" filterable v-else>
						<el-option v-for="item in shelves" :key="item._id" :label="item.name" :value="item._id">
							{{ item.name }}
						</el-option>
					</el-select>
				</el-form-item>
				<div class="excomChoose">
					<el-form-item prop="partner" class="input-with-partner">
						<partner class="partner" ref="excom" v-model="ruleForm.partner" @datachange="partnerChange"/>
					</el-form-item>
					<el-form-item prop="code"
					              class="input-with-select">
						<el-input v-model.trim="ruleForm.code"
						          placeholder="输入快递单号"
						          class="fonticon courierCode"
						          suffix-icon="icon-saomaqiang"
						          clearable @keyup.native.enter="nextInput"
						          @change="dealCode"
						          ref="code"></el-input>
					</el-form-item>
				</div>
				<div class="phonetips">
					<ul class="phonetips-content">
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[0]}">{{ ruleForm.phone[0] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[1]}">{{ ruleForm.phone[1] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[2]}">{{ ruleForm.phone[2] }}
						</li>
						<li class="phonetips-content-space">-</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[3]}">{{ ruleForm.phone[3] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[4]}">{{ ruleForm.phone[4] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[5]}">{{ ruleForm.phone[5] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[6]}">{{ ruleForm.phone[6] }}
						</li>
						<li class="phonetips-content-space">-</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[7]}">{{ ruleForm.phone[7] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[8]}">{{ ruleForm.phone[8] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[9]}">{{ ruleForm.phone[9] }}
						</li>
						<li class="phonetips-content-list" :class="{active:ruleForm.phone[10]}">{{ ruleForm.phone[10] }}
						</li>
					</ul>
				</div>
				<el-form-item prop="phone" class="phoneInput">
					<el-autocomplete
						:select-when-unmatched="true"
						trigger-on-focus ref="phoneFocus"
						v-model="ruleForm.phone"
						valueKey="phone"
						:fetch-suggestions="searchPhoneAsync"
						@select="phoneSelect"
						type="text"
						:debounce="500"
						placeholder="输入手机号码"
						suffix-icon="el-icon-phone-outline"
						id="phoneInput"
						@change="phoneChange">
						<template slot-scope="{ item }">
							<div class="phoneInputList">
								<span class="name">{{ item.phone }}</span>
								<span class="addr">{{ item.name }}</span>
							</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item prop="name" class="phoneInput">
					<el-input v-model="ruleForm.name" placeholder="请输入收件人姓名"
					          @keyup.native.enter="submitData"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="inbound-btn-agree" @click="submitData" v-if="inboundType == 0" :loading="sumiting">
						立即入库
					</el-button>
					<el-button type="primary" class="inbound-btn-agree" @click="submitData" v-else :loading="sumiting">批量入库</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 批量入库显示的 -->
		<el-card class="box-card rukulist drag" v-if="inboundType == 1">
			<div slot="header" class="clearfix">
				<span>待入库列表（ 共计:{{batchList.length}} ）</span>
				<span class="rukulist-swich">
                    发送通知<el-switch v-model="smssend"/>
                </span>
			</div>
			<div class="rukulist-table">
				<el-table :data="batchList" style="width: 100%">
					<el-table-column prop="code" width="140" show-overflow-tooltip label="单号"></el-table-column>
					<el-table-column prop="partner.name" label="快递员"></el-table-column>
					<el-table-column prop="phone" width="98" label="电话"></el-table-column>
					<el-table-column prop="serial" label="编号"></el-table-column>
				</el-table>
			</div>
			<div class="rukulist-footer">
				<el-button type="primary" @click="sendsms">发送短信</el-button>
			</div>
		</el-card>
		<div class="printer">
			<el-button type="success" icon="el-icon-printer" circle @click="printerShowAction"></el-button>
		</div>
		<PrintPickCode v-if="printerShow" @close="closePrinte" @changePrintType="changePrintType" ref="printPickCode"/>
	</div>
</template>

<script type="text/babel">
	import partner from '../../components/partner.vue'
	import PrintPickCode from './components/printPickCode.vue'
	import {mapActions, mapState} from 'vuex';

	export default {
		components: {
			partner,
			PrintPickCode,
		},
		data() {
			return {
				inboundType: '0',
				scale: 1,
				smssend: false,
				parcelCode: '',
				batchList:[],
				curPartner: {},
				sumiting: false,
				phonetips:[],
				phoneFlag: false,
				newList:[],
				ztoCheckInfo: null,
				codeCheckResult: null,
				forceSubmit: false,
				printerShow: false,
				printType: '0',
				ruleForm: {
					isSecretWayBill: false,
					name: '',
					phone: '',
					shelf: '',
					code: '',
					partner: '',
				}
			};
		},
		created() {
			const scale = window.localStorage.getItem('scale');
			this.scale = Number(scale);
			this.getInitData();
		},
		mounted(){
			this.codeFocus();
		},
		computed: {
			...mapState('site', {
				shelves: state => state.shelves,
				vipshelfstrict: state => state.info.stype === 1 && state.info.vipshelfstrict,
			}),
			rules() {
				return {
					phone: [
						{required: true, message: '请输入电话号码', trigger: 'change'},
						{min: 11, max: 11, message: '电话号码是11位数', trigger: 'change'}
					],
					partner: [
						{required: true, message: '请选择快递员', trigger: 'change'}
					],
					type: [
						{type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}
					],
					shelf: [
						{required: true, message: '请选择货架', trigger: 'change'}
					],
					code: [
						{required: true, message: '请填写快递单号', trigger: 'blur'}
					]
				}
			}
		},
		methods: {
			...mapActions('inbound', ['putStorage','getPhoneTips','getCodeInfo','putStorage','putBatchStorage']),
			...mapActions('packageslist', ['againSendSms']),
			...mapActions('site', ['getShelves']),
			async getInitData(){
				await this.getShelves();
				// 设置第一个货架为默认货架;
				this.ruleForm.shelf = this.shelves[0]._id;
				const batchList = window.localStorage.getItem('batchList');
				if(batchList){
					this.batchList = JSON.parse(batchList);
				}
			},
			partnerChange(val){
				this.curPartner = val;
			},
			async setCodeInfo(){
				this.dealCode();
				const code = this.ruleForm.code;
				const {
					isSecretWayBill,
					isSensitiveConsumer,
					name,
					partner,
					phonestr,
					phonetips,
					phoneFlag,
					ztoCheckInfo,
					codeCheckResult,
				} = await this.getCodeInfo({ code });
				// 判断是否在隐私面单的黑名单里面
				if(isSensitiveConsumer){
					this.$message.error('此客户在菜鸟隐私面单黑名单里面');
					return false;
				}
				// 匹配快递员的判断
				if(partner.length === 0){
					this.$message.error('未能匹配到相应的快递员,请手动选择');
				}
				if(partner.length === 1){
					this.curPartner = partner[0];
					this.ruleForm.partner = partner[0]._id;
				}
				if(partner.length > 1){
					this.$message.error('匹配到多个快递员,请选择快递员或者禁用其中一个');
				}
				this.phonetips = phonetips;
				// 设置电话号码
				if(phonetips.length === 1){
					this.ruleForm.phone = phonetips[0].phone;
				}
				// todo 需要优化
				if(phonetips.length > 1){
					this.ruleForm.phone = phonestr;
				}
				this.ruleForm.name = name;
				this.ruleForm.isSecretWayBill = isSecretWayBill;
				this.phoneFlag = phoneFlag || false;
				// 判断phoneFlag
				if(phoneFlag){
					if(phonestr.indexOf('*') > -1){
						this.ruleForm.phone = phonetips.length > 0 ? phonetips[0].phone : '';
					}else{
						this.ruleForm.phone = phonestr;
					}
				}
				// 中通单号检查
				this.ztoCheckInfo = ztoCheckInfo;
				this.codeCheckResult = codeCheckResult;
				return true;
			},
			codeFocus(){
				this.$refs.code.focus();
			},
			phoneFocus(){
				this.$refs.phoneFocus.focus();
			},
			closePrinte(){
				this.printerShow = false;
				window.localStorage.setItem('printerShow', 0);
			},
			printerShowAction(){
				this.printerShow = !this.printerShow;
				window.localStorage.setItem('printerShow', this.printerShow ? 1 : 0);
			},
			async nextInput() {
				const result = await this.setCodeInfo();
				if(result){
					const isSecretWayBill = this.ruleForm.isSecretWayBill;
					const phoneFlag = this.phoneFlag;
					// 如果是隐私面单或者是申通获取到的电话直接提交
					if(this.codeCheckResult){
						this.$notify({
							title: '请注意',
							message: `${this.codeCheckResult.message}-代码[${this.codeCheckResult.tipCode}]`,
							type: 'warning',
						})
					}
					if(isSecretWayBill || phoneFlag){
						// 做一下提示,中通问题件不提示
						if(!this.ztoCheckInfo){
							this.$notify({
								title: '获取收件人信息成功',
								message: `此面单为${isSecretWayBill ? '【菜鸟隐私面单】' : '【可获取收件人信息】'}面单，将直接入库不需要核对收件人信息`,
								type: 'success'
							});
						}
						this.submitData();
					}
					// 不是隐私面单才返回初始状态
					if(!isSecretWayBill) this.phoneFocus();
				}
			},
			checkForm(){
				return new Promise((resovle)=>{
					this.$refs['ruleForm'].validate((valid) => {
						resovle(valid);
					});
				})
			},
			phoneSelect(e) {
				if(e.phone){
					this.ruleForm.phone = e.phone
					this.ruleForm.name = e.name
				}
				this.submitData();
			},
			phoneChange(){

			},
			async submitData() {
				const checkForm = await this.checkForm();
				const checkMobile = this.checkMobile();
				const checkCode = await this.checkCode();
				if(checkForm && checkMobile && checkCode){
					this.sumbit();
				}
			},
			changePrintType(val){
				this.printType = val;
			},
			async sumbit(){
				this.sumiting = true;
				try {
					const res = await this.putStorage({
						...this.ruleForm,
						multi: this.inboundType === '1',
					});
					if(res.serial){
						this.parcelCode = res.serial;
						this.playVoice('0');
						this.resetInbondParams();
						if( this.inboundType === '1'){
							this.batchList.push(res);
							window.localStorage.setItem('batchList',JSON.stringify(this.batchList));
						}
					}else{
						this.playVoice(res.code);
						this.$message.error(res.message);
					}
					this.sumiting = false;
				}catch(e){
					this.sumiting = false;
				}

			},
			checkMobile(){
				const isSecretWayBill = this.ruleForm.isSecretWayBill;
				if(isSecretWayBill) return true;
				const patrn = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;/\s+'\\[\]·~！@#￥%……&（）\+={}|《》？：“”【】、；‘’，。、]/g;
				this.ruleForm.phone = this.ruleForm.phone.replace(patrn,'');
				const mobileReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
				const result = mobileReg.test(this.ruleForm.phone);
				if(!result){
					this.$message.error('电话号码不符合规则')
				}
				return result;
			},
			async checkCode(){
				const code = this.ruleForm.code;
				const pinyin = this.curPartner.pinyin;
				// 检测单号长度
				const codeLength = code.length;
				if(codeLength < 10 || codeLength > 22){
					this.$message.error('单号长度不对');
					return false;
				}
				// 圆通单号判断
				if(pinyin === 'yuantong'){
					const index = code.indexOf('YT');
					console.log(index);
					if(index === -1){
						this.$message.error(codeLength === 15 ? '此单号可能是天猫的' : '圆通单号是以YT开头的');
						return false;
					}else if(index === 0 && codeLength !== 15){
						this.$message.error('圆通单号是15位长度');
						return false;
					}
				}
				// 韵达单号
				if(pinyin === 'zhongtong'){
					if(code.includes('A')
						|| code.includes('JD')
						|| code.includes('SF')
						|| code.includes('A')
						|| code.includes('ZJS')
						|| code.includes('LP')
						|| code.includes('PL')
						|| code.includes('SN')
						|| code.includes('TT')
					){
						this.$message.error('单号不符合韵达单号规则');
						return false;
					}
				}
				// 中通单号
				if(pinyin === 'zhongtong'){
					if(code.includes('A')
						|| code.includes('JD')
						|| code.includes('SF')
						|| code.includes('A')
						|| code.includes('ZJS')
						|| code.includes('LP')
						|| code.includes('PL')
						|| code.includes('SN')
						|| code.includes('TT')
					){
						this.$message.error('单号不符合中通单号规则');
						return false;
					}
				}
				// 中通单号拦截
				if(pinyin === 'zhongtong' && this.ztoCheckInfo){
					const result = await this.checkZtoBillIsForbid();
					return result;
				}
				// 单号检测
				return true;
			},
			checkZtoBillIsForbid(){
				return new Promise((resolve, reject) => {
					this.$confirm(`此件为中通问题件：${this.ztoCheckInfo.reason}`, '此件为中通标记的问题件', {
						confirmButtonText: '确认入库',
						cancelButtonText: '放弃入库',
						type: 'warning',
						center: true
					}).then(() => {
						resolve(true);
					}).catch(() => {
						resolve(false);
						this.resetInbondParams();
					});
				})

			},
			dealCode(){
				const code = this.ruleForm.code.toLocaleUpperCase();
				this.ruleForm.code = code;
				// 去除单号里面的异常字符
				const patrn = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;/\s+'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘’，。、]/g;
				this.ruleForm.code = code.replace(patrn,'');
			},
			async sendsms(){
				// 发送短信
				const idList = this.batchList.map((item) => item._id)
				const res = await this.againSendSms(idList.join(','))
				if(res){
					window.localStorage.removeItem('batchList')
					this.batchList = [];
					this.$message({ message: '发送成功', type: 'success' });
				}
			},
			resetForm() {
				this.$refs['ruleForm'].resetFields();
				this.ruleForm.partner = ''
			},
			resetInbondParams(){
				this.ruleForm.code = '';
				this.ruleForm.phone = '';
				this.ruleForm.name = '';
				this.ruleForm.isSecretWayBill = false;
				this.codeFocus();
			},
			// 播放音频
			playVoice(val){
				if(val == '8008'){
					this.$message.error('此快递员费用已不足扣除本次单价请提醒他充值!');
					const audio = new Audio(require('../../assets/owe.mp3'));
					audio.play();
				}else if(val == '8007'){
					this.$message.error('网点信息费没有了请及时充值!');
					const audio = new Audio(require('../../assets/onselfOwe.mp3'));
					audio.play();
				}else if(val == '8006'){
					this.$message.error('重复入库');
					const audio = new Audio(require('../../assets/ruku-fail.mp3'));
					audio.play();
				}else if(val == '8003'){
					this.$message.error('用户在黑名单里');
					const audio = new Audio(require('../../assets/ruku-fail.mp3'));
					audio.play();
				}else if(val == '0'){
					this.$notify({
						title: '成功',
						message: '入库成功',
						type: 'success'
					});
					const audio = new Audio(require('../../assets/ruku-success.mp3'));
					audio.play();
				}else if(val == '9012'){
					this.$notify({
						title: '失败',
						message: '严格的货架电话匹配模式下，电话必须先关联货架',
						type: 'error'
					});
					const audio = new Audio(require('../../assets/ruku-fail.mp3'));
					audio.play();
				}else{
					this.$message.error('入库错误，请检查!');
					const audio = new Audio(require('../../assets/ruku-fail.mp3'));
					audio.play();
				}
			},
			scaleChange(){
				window.localStorage.setItem('scale',this.scale);
			},
			// 异步查询电话号码
			async searchPhoneAsync(queryString, cb){
				if( !queryString && this.phonetips.length >= 1){
					return cb(this.phonetips);
				}
				if(!queryString){
					cb([])
				}
				if(this.ruleForm.phone.length > 3){
					const res = await this.getPhoneTips({
						phone: this.ruleForm.phone
					})
					cb(res)
				}else{
					cb([])
				}
			},
		}
	};
</script>

<style lang="less" rel="stylesheet/less">
	.inbound {
		&-type {
			display: block;
			position: absolute;
			top: 15px;
			left: 50%;
			transform: translate(-50%, 0);
		}
		.rukulist {
			width: 440px;
			.el-card__header{
				cursor: move;
			}
			.el-table .cell, .el-table th div {
				padding-right: 5px;
				padding-left: 5px;
			}
			.el-button--primary {
				width: 100%;
				margin-top: 20px;
			}
			&-swich {
				float: right;
				.el-switch {
					margin-left: 10px;
				}
			}
		}
		.ruku {
			width: 400px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 9;

			&.el-card {
				overflow: unset;
			}

			.el-radio-button--medium .el-radio-button__inner {
				padding: 10px 2px;
			}

			.el-select {
				display: block
			}

			.el-card_body {
				margin-bottom: -20px;
			}

			.el-button--text {
				font-size: 18px;

				padding: 0;

				span {
					color: red;
				}
			}
		}

		.phonetips {
			margin-bottom: 20px;
			overflow: hidden;

			&-content {
				margin-right: -8px;

				&-list {
					float: left;
					list-style: none;
					border: 1px solid #ff4949;
					font-size: 20px;
					border-radius: 4px;
					font-weight: bold;
					margin-right: 5px;
					height: 30px;
					line-height: 30px;
					text-align: center;
					width: 23.2px;

					&.active {
						border-color: #13ce66;
					}
				}

				&-space {
					float: left;
					list-style: none;
					line-height: 32px;
					margin-right: 5px;
				}
			}

		}
		.shelf-radio-group{
			display: flex;
			width: 100%;
			.el-radio-button{
				flex: 1;
				.el-radio-button__orig-radio,.el-radio-button__inner{
					width: 100%;
				}
			}
		}
		.excomChoose{
			display: flex;
		}
		.input-with-partner{
			width: 120px;
			.partner{
				.el-input__inner{
					border-radius: 4px 0 0 4px !important;
				}
			}
		}
		.input-with-select{
			width: 238px;
			.el-form-item__content{
				display: flex;
			}
			.courierCode{
				.el-input__inner{
					border-radius: 0 4px 4px 0 !important;
				}
			}
		}
		.phoneInput{
			.el-autocomplete{
				display: block;
			}
			.el-input__inner{
				font-size: 22px;
			}

		}
	}
	.courierCode{
		.el-input__inner{
			font-size: 18px;
		}
	}
	.phoneInputList{
		display: flex;
		justify-content: space-between;
	}
	.el-autocomplete-suggestion li.highlighted, .el-autocomplete-suggestion li:hover {
		background-color: #419efb !important;
		color: #fff !important;
	}
	.inbound-btn-agree{
		width: 280px;
	}
	.el-autocomplete-suggestion__list{
		li{
			font-size: 26px!important;
			font-weight: bold!important;
		}
	}
	.printer{
		position: fixed;
		bottom: 20px;
		right: 20px;
	}
</style>
